import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Utensils, Calendar, CheckSquare, ThermometerSun, Pill } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-203" />,
    title: 'El Manual Principal',
    desc: 'Perimenopausia: Entiende, Ajusta, Mejora (PDF).'
  }, {
    icon: <Utensils className="w-6 h-6" data-id="element-204" />,
    title: 'Protocolo PFG',
    desc: 'Protocolo Proteína-Fibra-Grasa para eliminar antojos.'
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-205" />,
    title: 'Plan de Acción',
    desc: 'Plan Detallado de 21 Días paso a paso.'
  }, {
    icon: <CheckSquare className="w-6 h-6" data-id="element-206" />,
    title: 'Checklist de Síntomas',
    desc: 'Herramienta de seguimiento hormonal diario.'
  }, {
    icon: <ThermometerSun className="w-6 h-6" data-id="element-207" />,
    title: 'Guía de Higiene de Sueño',
    desc: 'Estrategia térmica para eliminar despertares nocturnos.'
  }, {
    icon: <Pill className="w-6 h-6" data-id="element-208" />,
    title: 'Bono Especial',
    desc: 'Guía de Suplementos Naturales (Magnesio, Omega-3, Vitamina D).'
  }];
  return <section className="py-20 bg-cream" data-id="element-209">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-210">
        <FadeIn data-id="element-211">
          <div className="text-center mb-16" data-id="element-212">
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-213">
              Lo que obtienes hoy
            </h2>
            <div className="w-24 h-1 bg-sage mx-auto rounded-full" data-id="element-214"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-215">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-216">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-sage-light/50 hover:border-sage transition-colors h-full" data-id="element-217">
                <div className="w-12 h-12 bg-sage-light text-sage-dark rounded-xl flex items-center justify-center mb-4" data-id="element-218">
                  {item.icon}
                </div>
                <h3 className="font-bold text-forest text-lg mb-2" data-id="element-219">
                  {item.title}
                </h3>
                <p className="text-forest/70" data-id="element-220">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}